function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_793",
  "data-name": "Rectangle 793",
  transform: "translate(817 643)",
  fill: "#fff",
  stroke: "rgba(0,0,0,0.12)",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 199,
  height: 44,
  rx: 22,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 198,
  height: 43,
  rx: 21.5,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_936",
  "data-name": "Group 936",
  transform: "translate(301 198)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_794",
  "data-name": "Rectangle 794",
  width: 24,
  height: 24,
  transform: "translate(533 455)",
  fill: "#fff",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_935",
  "data-name": "Group 935",
  transform: "translate(535 455)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1503",
  "data-name": "Path 1503",
  d: "M181.743,107.937h-.168a.973.973,0,0,0-.6-1.079l.084-.148A1.143,1.143,0,0,1,181.743,107.937Z",
  transform: "translate(-171.011 -95.115)",
  fill: "#a7a530"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1504",
  "data-name": "Path 1504",
  d: "M186.7,110.918h-.168v-4.429c0-.543.661-.984.945-1.149l.084.147c-.543.311-.861.686-.861,1Z",
  transform: "translate(-175.967 -93.893)",
  fill: "#9e9925"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1505",
  "data-name": "Path 1505",
  d: "M151.571,89.708a1.157,1.157,0,0,1-.531-.152c-.362-.189-3.694-2.134-3.84-2.217l.086-.147c.035.021,3.477,2.027,3.831,2.212a.773.773,0,0,0,.878,0l3.836-2.214.084.147-3.835,2.214A1,1,0,0,1,151.571,89.708Z",
  transform: "translate(-140.911 -77.716)",
  fill: "#b2b237"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1506",
  "data-name": "Path 1506",
  d: "M195.618,153.4a1.612,1.612,0,0,0-.612-1.078,1.584,1.584,0,0,0-.191-.128,1.537,1.537,0,0,0-.195-.1,1.636,1.636,0,0,0-1.436.095l-4.7,2.716-1.151.665a1.435,1.435,0,0,1-.718.192h-.085v3.694h.168v-.005a1.925,1.925,0,0,0,.869-.252l7.248-4.183A1.621,1.621,0,0,0,195.618,153.4Z",
  transform: "translate(-175.967 -135.466)",
  fill: "#29a8cc"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_20",
  "data-name": "Ellipse 20",
  cx: 0.444,
  cy: 0.444,
  r: 0.444,
  transform: "translate(15.92 8.863) rotate(-11.82)",
  fill: "#9e9925"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1507",
  "data-name": "Path 1507",
  d: "M255.528,86.631a.446.446,0,0,0-.606-.163l-.543.316a.444.444,0,1,0,.443.769l.543-.316a.443.443,0,0,0,.163-.606Z",
  transform: "translate(-236.229 -77.019)",
  fill: "#9e9925"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1508",
  "data-name": "Path 1508",
  d: "M238.5,113.243l-.9.517a.444.444,0,1,0,.444.769l.9-.517a.444.444,0,0,0-.444-.769Z",
  transform: "translate(-221.284 -100.89)",
  fill: "#9e9925"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1509",
  "data-name": "Path 1509",
  d: "M110.738,5.69a.324.324,0,0,0-.008-.086c-.008-.028-.008-.03-.011-.046a1.719,1.719,0,0,0-.075-.273,1.692,1.692,0,0,0-.192-.374,1.553,1.553,0,0,0-.354-.379,1.915,1.915,0,0,0-.189-.127L102.718.254a1.919,1.919,0,0,0-1.918,0L92.07,5.294a1.916,1.916,0,0,0-.652.631h-.005L91.371,6h0l-.041.073,3.2,1.847.041-.074h0a1.439,1.439,0,0,1,.528-.529l.24-.138h0l3.819-2.206,1.889-1.087a1.434,1.434,0,0,1,1.438,0l5.851,3.378a1.643,1.643,0,0,0,.305.133c.035.011.067.025.1.034s.093.018.14.027c.025,0,.049.011.074.013.047.005.093.007.14.008h.076A1.63,1.63,0,0,0,110,7.235a1.291,1.291,0,0,0,.115-.083c.023-.016.048-.032.07-.049s.033-.033.05-.048c.037-.034.075-.066.109-.1.016-.018.028-.037.043-.055.03-.037.062-.073.089-.109.005-.008.009-.016.014-.025a1.617,1.617,0,0,0,.262-.953A1.032,1.032,0,0,1,110.738,5.69Z",
  transform: "translate(-91.112 0.003)",
  fill: "#e33854"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_21",
  "data-name": "Ellipse 21",
  cx: 0.444,
  cy: 0.444,
  r: 0.444,
  transform: "translate(15.92 8.863) rotate(-11.82)",
  fill: "#9e9925"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1510",
  "data-name": "Path 1510",
  d: "M255.528,86.631a.446.446,0,0,0-.606-.163l-.543.316a.444.444,0,1,0,.443.769l.543-.316a.443.443,0,0,0,.163-.606Z",
  transform: "translate(-236.229 -77.019)",
  fill: "#9e9925"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1511",
  "data-name": "Path 1511",
  d: "M238.5,113.243l-.9.517a.444.444,0,1,0,.444.769l.9-.517a.444.444,0,0,0-.444-.769Z",
  transform: "translate(-221.284 -100.89)",
  fill: "#9e9925"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1512",
  "data-name": "Path 1512",
  d: "M146.539,87.89a.945.945,0,0,0-.129.479v4.02a.978.978,0,0,0,.48.83l3.484,2.011a.958.958,0,0,0,.48.128V90.935a.961.961,0,0,0-.48-.831Z",
  transform: "translate(-140.207 -78.34)",
  fill: "#a7a530"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1513",
  "data-name": "Path 1513",
  d: "M194.231,87.837a.2.2,0,0,0,.021-.022.342.342,0,0,0,.041-.048c.007-.009.012-.02.018-.029a.413.413,0,0,0,.026-.05.328.328,0,0,0,.013-.035.394.394,0,0,0,.014-.051.233.233,0,0,0,.007-.038.425.425,0,0,0,0-.053c0-.013,0-.025,0-.038a.466.466,0,0,0-.008-.054.144.144,0,0,0-.009-.036.36.36,0,0,0-.023-.056.276.276,0,0,0-.013-.032.531.531,0,0,0-.05-.072.365.365,0,0,0-.07-.066l-.014-.01a.487.487,0,0,0-.051-.03.435.435,0,0,0-.065-.027h0a.488.488,0,0,0-.378.045l-.869.5-1.468.848a.444.444,0,0,1-.361.035h0a.378.378,0,0,1-.116-.058l-.014-.01a.351.351,0,0,1-.063-.058.009.009,0,0,0-.007-.009.535.535,0,0,1-.047-.064v-.008c-.005-.01-.009-.021-.014-.032a.391.391,0,0,1-.022-.055.057.057,0,0,0-.009-.037c-.009-.012-.007-.036-.009-.054a.217.217,0,0,1,0-.038.425.425,0,0,1,0-.053.233.233,0,0,1,.007-.038.451.451,0,0,1,.014-.051.328.328,0,0,1,.013-.035.347.347,0,0,1,.026-.049l.018-.03a.426.426,0,0,1,.04-.048c.008-.007.013-.015.021-.022a.446.446,0,0,1,.077-.058l.446-.256.446-.258.505-.291a.48.48,0,0,0,.227-.3h0a.371.371,0,0,0,.01-.068.591.591,0,0,0,0-.062v-.014a.474.474,0,0,0-.024-.1.455.455,0,0,0-.036-.077l-.021-.028a.4.4,0,0,0-.038-.047.307.307,0,0,0-.027-.026c-.014-.012-.028-.024-.042-.034l-.033-.021a.478.478,0,0,0-.048-.023l-.036-.014a.459.459,0,0,0-.052-.013h-.037a.473.473,0,0,0-.055,0h-.036a.6.6,0,0,0-.061.011l-.029.007a.414.414,0,0,0-.087.038h0l-1.468.848h0L187.789,88.5a.959.959,0,0,0-.479.831v4.428a.957.957,0,0,0,.479-.128l3.964-2.288h0l.591-.341a.477.477,0,0,0,.227-.3h0a.457.457,0,0,0,.009-.067.4.4,0,0,0,0-.062.072.072,0,0,0,0-.015.356.356,0,0,0-.024-.095.435.435,0,0,0-.036-.078c-.007-.01-.014-.018-.021-.027a.425.425,0,0,0-.037-.048l-.028-.025a.316.316,0,0,0-.075-.054.391.391,0,0,0-.048-.024.238.238,0,0,0-.036-.013.406.406,0,0,0-.052-.013.2.2,0,0,0-.037-.007.452.452,0,0,0-.055,0H192.1a.544.544,0,0,0-.061.011l-.03.008a.384.384,0,0,0-.087.038l-.164.095h0l-.991.572-.167.1a.444.444,0,0,1-.361.035h0A.436.436,0,0,1,190.17,91a.5.5,0,0,1-.051-.032l-.014-.009a.358.358,0,0,1-.063-.059.026.026,0,0,1-.007-.009.38.38,0,0,1-.046-.064v-.008a.28.28,0,0,1-.015-.032.581.581,0,0,1-.022-.055.152.152,0,0,0-.009-.037.466.466,0,0,1-.008-.054V90.6a.431.431,0,0,1,0-.053.233.233,0,0,1,.007-.038.445.445,0,0,1,.014-.051l.013-.035a.423.423,0,0,1,.026-.049l.018-.03a.413.413,0,0,1,.04-.047c.008-.008.014-.016.022-.023a.4.4,0,0,1,.076-.057h0l2.614-1.51h0l1.391-.8A.4.4,0,0,0,194.231,87.837Z",
  transform: "translate(-176.662 -76.729)",
  fill: "#9e9925"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1514",
  "data-name": "Path 1514",
  d: "M152.394,69.661l1.179-.68,1.444-.833h0l1.21-.7a.951.951,0,0,0-.35-.351l-3.484-2.012a.958.958,0,0,0-.959,0L147.951,67.1a.946.946,0,0,0-.351.351l3.835,2.213A.958.958,0,0,0,152.394,69.661Z",
  transform: "translate(-141.267 -57.897)",
  fill: "#b2b237"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1515",
  "data-name": "Path 1515",
  d: "M182.89,108.26a.961.961,0,0,1,.48.831.96.96,0,0,1,.479-.831A.958.958,0,0,1,182.89,108.26Z",
  transform: "translate(-172.723 -96.496)",
  fill: "#a19b32"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1516",
  "data-name": "Path 1516",
  d: "M99.248,69.295l-2.186-1.263L93.54,66l-.235-.138a1.442,1.442,0,0,1-.725-1.247V57.748a1.437,1.437,0,0,1,.194-.72l-3.2-1.847a1.919,1.919,0,0,0-.256.958V66.222a1.917,1.917,0,0,0,.959,1.66l8.729,5.039a1.915,1.915,0,0,0,.959.258V69.485A1.44,1.44,0,0,1,99.248,69.295Z",
  transform: "translate(-89.32 -49.184)",
  fill: "#394868"
})));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1525",
  "data-name": "Path 1525",
  d: "M63.133,28H60.875V19.285l-2.695.832V18.3l4.711-1.687h.242Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1526",
  "data-name": "Path 1526",
  d: "M76,24.211A4.031,4.031,0,0,1,74.645,27.1a4.764,4.764,0,0,1-3.223,1.054,4.283,4.283,0,0,1-3.442-1.472,6.043,6.043,0,0,1-1.253-4.043v-.7a6.81,6.81,0,0,1,.578-2.891,4.33,4.33,0,0,1,1.652-1.918,5.163,5.163,0,0,1,5.668.387,4.326,4.326,0,0,1,1.391,2.961H73.672a2.382,2.382,0,0,0-.613-1.6,2.272,2.272,0,0,0-1.606-.5,1.992,1.992,0,0,0-1.754.84,4.7,4.7,0,0,0-.6,2.6v.86a5.042,5.042,0,0,0,.558,2.7,1.956,1.956,0,0,0,1.762.851,2.313,2.313,0,0,0,1.621-.5,2.243,2.243,0,0,0,.613-1.535Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1527",
  "data-name": "Path 1527",
  d: "M82.289,28a2.489,2.489,0,0,1-.226-.758,2.73,2.73,0,0,1-2.133.914,3,3,0,0,1-2.059-.718,2.313,2.313,0,0,1-.816-1.813,2.389,2.389,0,0,1,1-2.062,4.906,4.906,0,0,1,2.879-.727h1.039v-.484a1.4,1.4,0,0,0-.3-.938,1.185,1.185,0,0,0-.949-.351,1.346,1.346,0,0,0-.9.273.931.931,0,0,0-.324.75H77.242a2.269,2.269,0,0,1,.453-1.359,3,3,0,0,1,1.282-.981,4.662,4.662,0,0,1,1.859-.355,3.691,3.691,0,0,1,2.48.785,2.746,2.746,0,0,1,.918,2.207v3.664a4.046,4.046,0,0,0,.336,1.82V28Zm-1.867-1.57a1.939,1.939,0,0,0,.922-.223,1.463,1.463,0,0,0,.625-.6V24.156h-.844q-1.695,0-1.805,1.172l-.007.133a.9.9,0,0,0,.3.695A1.151,1.151,0,0,0,80.422,26.43Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1528",
  "data-name": "Path 1528",
  d: "M88.086,19.547l.07.945a2.972,2.972,0,0,1,2.43-1.1,2.255,2.255,0,0,1,2.242,1.289,2.9,2.9,0,0,1,2.539-1.289,2.518,2.518,0,0,1,2.047.8,3.68,3.68,0,0,1,.672,2.41V28H95.82V22.6a1.613,1.613,0,0,0-.281-1.053,1.243,1.243,0,0,0-.992-.333,1.409,1.409,0,0,0-1.406.971L93.148,28H90.891V22.6A1.6,1.6,0,0,0,90.6,21.54a1.259,1.259,0,0,0-.985-.329,1.463,1.463,0,0,0-1.39.8V28H85.969V19.547Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1529",
  "data-name": "Path 1529",
  d: "M107.43,23.852a5.073,5.073,0,0,1-.887,3.129,2.844,2.844,0,0,1-2.395,1.175,2.632,2.632,0,0,1-2.07-.89V31.25H99.82v-11.7h2.094l.078.828a2.654,2.654,0,0,1,2.141-.984,2.864,2.864,0,0,1,2.429,1.156,5.2,5.2,0,0,1,.868,3.188Zm-2.258-.172a3.35,3.35,0,0,0-.418-1.826,1.36,1.36,0,0,0-1.215-.643,1.478,1.478,0,0,0-1.461.815V25.5a1.5,1.5,0,0,0,1.477.839Q105.172,26.336,105.172,23.68Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1530",
  "data-name": "Path 1530",
  d: "M113.891,27.141a2.834,2.834,0,0,1-2.313,1.015,2.669,2.669,0,0,1-2.074-.781,3.33,3.33,0,0,1-.731-2.289V19.547h2.258v5.467q0,1.323,1.2,1.322a1.628,1.628,0,0,0,1.578-.8V19.547h2.266V28h-2.125Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1531",
  "data-name": "Path 1531",
  d: "M122.359,25.664a.726.726,0,0,0-.41-.652,4.658,4.658,0,0,0-1.316-.426q-3.017-.633-3.016-2.562a2.322,2.322,0,0,1,.934-1.879,3.76,3.76,0,0,1,2.441-.754,4.055,4.055,0,0,1,2.574.758,2.388,2.388,0,0,1,.965,1.968h-2.258a1.092,1.092,0,0,0-.312-.8,1.324,1.324,0,0,0-.977-.317,1.348,1.348,0,0,0-.882.258.813.813,0,0,0-.313.656.7.7,0,0,0,.356.606,3.66,3.66,0,0,0,1.2.4,9.789,9.789,0,0,1,1.422.379,2.337,2.337,0,0,1,1.789,2.274,2.206,2.206,0,0,1-.993,1.871,4.283,4.283,0,0,1-2.562.714,4.477,4.477,0,0,1-1.887-.378,3.164,3.164,0,0,1-1.293-1.04,2.415,2.415,0,0,1-.468-1.425h2.14a1.18,1.18,0,0,0,.445.922,1.771,1.771,0,0,0,1.11.32,1.634,1.634,0,0,0,.98-.246A.767.767,0,0,0,122.359,25.664Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1532",
  "data-name": "Path 1532",
  d: "M133.751,18.645a7.922,7.922,0,0,0,1.36-1.729h-3.632V15.379H137v1.249a8.91,8.91,0,0,1-1.488,2.5h3.968a13.059,13.059,0,0,1-2.288-3.441l1.393-.769A10.632,10.632,0,0,0,139.5,16.6a8.718,8.718,0,0,0,1.44-1.441l1.169,1.041a9.612,9.612,0,0,1-1.712,1.6,7.5,7.5,0,0,0,.864.9,9.138,9.138,0,0,0,1.713-1.713L144.139,18a9.847,9.847,0,0,1-1.7,1.665,16.583,16.583,0,0,0,2.337,1.425l-1.1,1.28a17.623,17.623,0,0,1-3.265-2.321v.593h-5.875v-.513a13.663,13.663,0,0,1-3.793,2.273l-1.025-1.312a13.341,13.341,0,0,0,2.865-1.489,18.487,18.487,0,0,0-1.889-1.489l1.121-1.056A21.389,21.389,0,0,1,133.751,18.645Zm1.969,9.092h3.025a13.943,13.943,0,0,0,1.169-1.906l1.552.561a14.305,14.305,0,0,1-.912,1.345h3.489v1.584H130.182V27.737h3.761a8.655,8.655,0,0,0-1.185-1.265l1.569-.593A9.808,9.808,0,0,1,135.72,27.737Zm6.066-6.115v4.161h-9.252V21.622ZM140.1,23.078h-5.89v1.233h5.89Z",
  fill: "rgba(0,0,0,0.6)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1533",
  "data-name": "Path 1533",
  d: "M150.311,17.028V15.4h3.57a19.383,19.383,0,0,0,6.562,12.741l-.961,1.44a20.628,20.628,0,0,1-6.273-9.908,17.638,17.638,0,0,1-6.483,9.876L145.7,28.1a18.144,18.144,0,0,0,6.819-11.077Z",
  fill: "rgba(0,0,0,0.6)"
});

var SvgSignInWith1Campus = function SvgSignInWith1Campus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 44,
    viewBox: "0 0 199 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "sign-in-with-1campus",
    transform: "translate(-817 -643)"
  }, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "_1Campus_\\u767B\\u5165",
    "data-name": " 1Campus \\u767B\\u5165",
    transform: "translate(816.82 642.085)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    style: {
      isolation: "isolate"
    }
  }, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10), /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    style: {
      isolation: "isolate"
    }
  }, _ref11, _ref12))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignInWith1Campus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-in-with-1campus.2175f321.svg";
export { ForwardRef as ReactComponent };